import React, {useEffect, useState, useRef} from 'react';
import {
    DataGrid,
    GridToolbar
} from '@mui/x-data-grid';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Alert,
    AlertTitle,
    MenuItem,
    Select,
    InputLabel,
    FormControl
} from '@mui/material';
import DeleteAdtCompanyDialog from '../components/DeleteAdtCompanyDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {styled} from '@mui/system';
import Cookies from 'js-cookie';
import {sendDataToApi} from '../../../API/apiHelper';
import EditAdtCompanyDialog from '../components/EditAdtCompanyDialog';


const StyledDataGrid = styled(DataGrid)(({theme}) => ({
    '& .MuiDataGrid-row': {
        '&:nth-child(even)': {
            backgroundColor: '#eaf0f5',
        },
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold',
    },
    '& .MuiDataGrid-cell': {
        whiteSpace: 'normal !important',
        wordWrap: 'break-word',
    },
    '& .total-row': {
        backgroundColor: '#f8fff9',
        fontWeight: 'bold',
    },
}));

function processData(data) {
    if (!data || !Array.isArray(data) || data.length === 0) return [];
    const processedData = data.map(row => ({
        id: row.value.id,
        ...row.value,
    }));

    if (processedData.length > 1) {
        processedData[processedData.length - 1].total = true;
    }

    return processedData;
}

const AdtCompanyDataGrid = ({data, onRowEdit}) => {
    const [rows, setRows] = useState(processData(data));
    const [openDelete, setOpenDelete] = useState(false);
    const [editRow, setEditRow] = useState({});
    const [openEdit, setOpenEdit] = useState(false);
    const [openSend, setOpenSend] = useState(false);
    const gridRef = useRef(null);

    useEffect(() => {
        setRows(processData(data));
    }, [data]);

    const userAdmin = Cookies.get('user_admin');

    const handleDeleteButtonClick = (row) => {
        setEditRow(row);
        setOpenDelete(true);
    };

    const handleDeleteClose = () => {
        setOpenDelete(false);
    };

    const handleRowDelete = (deletedRowId) => {
        setRows(rows.filter(row => row.id !== deletedRowId));
    };

    const handleEditClick = (row) => {
        console.log(row);
        setEditRow(row);
        setOpenEdit(true);
    };

    const handleCloseEdit = () => {
        setOpenEdit(false);
    };

    const handleCloseSend = () => {
        setOpenSend(false);
    };

    const openSendSuccess = () => {
        setOpenSend(true);
    };

    const handleSave = () => {
        const userId = localStorage.getItem('user_id');
        const updatedCompany = {
            ...editRow,
            ChangedBy: userId,
        };

        sendDataToApi('post', '/api/adtimizer/company/update', updatedCompany, false, (res) => {
            const updatedArray = rows.map(item =>
                item.id === editRow.id ? {...editRow} : item
            );
            setRows(updatedArray);
            setOpenEdit(false);
            openSendSuccess();
            onRowEdit();
        });
    };

    const handleInputChange = (event) => {
        const {name, value} = event.target;
        setEditRow({...editRow, [name]: value});
    };

    const columns = [
        {
            field: 'edit',
            headerName: '',
            width: 100,
            renderCell: (params) => (
                <Button
                    variant="outlined"
                    startIcon={<EditIcon/>}
                    color="primary"
                    size="medium"
                    onClick={() => handleEditClick(params.row)}
                >
                    Edit
                </Button>
            )
        },
        {
            field: 'delete',
            headerName: '',
            width: 130,
            renderCell: (params) => (
                <Button
                    variant="outlined"
                    startIcon={<DeleteIcon/>}
                    color="error"
                    size="medium"
                    onClick={() => handleDeleteButtonClick(params.row)}
                    disabled={userAdmin !== '1'}
                >
                    Delete
                </Button>
            )
        },
        { field: 'id', headerName: 'ID', width: 80 },
        { field: 'company_name', headerName: 'Company Name', width: 200 },
        { field: 'adt_domain_name', headerName: 'Adtimizer Domain', width: 200 },
        { field: 'irtb_id_dsp', headerName: 'iRTB DSP ID', width: 120 },
        { field: 'sh_id', headerName: 'SmartHub ID', width: 120 },
        { field: 'wl_id_web', headerName: 'WEB White List', width: 150 },
        { field: 'wl_id_inapp', headerName: 'INAPP White List', width: 150 },
        { field: 'wl_id_ctv', headerName: 'CTV White List', width: 150 },
        { field: 'threshold', headerName: 'Threshold', width: 120 },
        { field: 'remove_all', headerName: 'Remove All', width: 120 },
        { field: 'created_at', headerName: 'Created At', width: 160 },
    ];

    if (rows.length === 0) {
        return null;
    }

    return (
        <div style={{height: 800, width: '100%'}} ref={gridRef}>
            <StyledDataGrid
                rows={rows}
                columns={columns}
                pageSize={25}
                slots={{
                    toolbar: GridToolbar,
                }}
                disableRowSelectionOnClick
            />

            <Dialog open={openSend} onClose={handleCloseSend}>
                <Alert severity="success">
                    <AlertTitle>Success</AlertTitle>
                    Company updated <strong>successfully!</strong>
                </Alert>
            </Dialog>

            <EditAdtCompanyDialog
                open={openEdit}
                handleClose={handleCloseEdit}
                data={editRow}
                onChange={handleInputChange}
                onSave={handleSave}
            />

            <DeleteAdtCompanyDialog
                open={openDelete}
                handleClose={handleDeleteClose}
                editRow={editRow}
                onDeleteSuccess={handleRowDelete}
            />
        </div>
    );
};

export default AdtCompanyDataGrid;
